/**
 * Типы для системы шаблонов результата
 */

/**
 * Идентификаторы шаблонов — единственный источник истины.
 * Использовать RESULT_TEMPLATES.XXX вместо строковых литералов во всём коде.
 */
export const RESULT_TEMPLATES = {
	DEFAULT:    'default',    // Стандартный
	TEXT_CARDS: 'textCards',  // Карточки с текстом/изображением
} as const;

export type ResultTemplateId = typeof RESULT_TEMPLATES[keyof typeof RESULT_TEMPLATES];
